import React from "react";
import classNames from "classnames";
import {Breadcrumbs} from "@mui/material";
import BaseLayout from "@/Layouts/BaseLayout";
import Link from "@/Layouts/Link";
import Picture from "@/Components/Picture";
import "@/Pages/Collections/scss/collections-page.scss";

const Index = (props) => {
    const {collectionsData = []} = props;

    return <BaseLayout {...props}>
        <section className={`section`}>
            <div className={`container`}>
                <Breadcrumbs maxItems={2} itemsAfterCollapse={2} className={`breadcrumbs`}>
                    <Link className={`breadcrumbs__link`} href={`/`}>Главная</Link>
                    <p className={`breadcrumbs__text`}>Коллекции</p>
                </Breadcrumbs>
                <h1 className={`h1`}>Коллекции</h1>
                <div className={`collections-wrapper`}>
                    {collectionsData.map((el, i) => {
                        let numberElement = false, showSmall = false;

                        if (i % 2 == 0) {
                            showSmall = true;
                        }

                        if ((i + 1) % 3 === 0) {
                            numberElement = true;
                        }

                        const collectionsClass = classNames('collections-wrapper__item', props.className, {
                            'collections-wrapper__item_showsmall': showSmall,
                            'number_3': numberElement
                        });

                        return (
                            <Link key={el.id} href={`${el.link}`} className={collectionsClass}>
                                <div className={`img-wrap`}>
                                    <div className={`box-img`}>
                                        <Picture src={el.imgFull} alt={el.alt} imageClassName={`increase`} />
                                    </div>
                                </div>
                                <span className={`name`}><span className={`line`}></span>{el.name}</span>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </section>
    </BaseLayout>
}

export default Index;
